<input [matDatepicker]="myDatepicker">
<mat-datepicker #myDatepicker></mat-datepicker>